// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"9af43a52","282":"9af43a52","333":"50386f81","734":"50386f81","768":"9af43a52","816":"6fd4d9f5","991":"6fd4d9f5"}[chunkId] + ".chunk.css";
};